import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { UserProvider } from './providers/UserContext';
import { BrowserRouter } from 'react-router-dom';


if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js') // ← Bổ sung dòng này để đăng ký
      .then((reg) => {
        console.log('✅ Service worker registered', reg);

        const sw = reg.active || navigator.serviceWorker.controller;

        if (sw) {
          console.log("✅ Đã tìm thấy service worker, gửi message...");
        //   sw.postMessage({
        //     title: "Ping",
        //     body: "Từ trang chính",
        //   });
        } else {
          console.warn("⚠️ Không tìm thấy service worker đang active");
        }
      })
      .catch((err) => console.error('❌ SW registration failed:', err));
  });
}


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<BrowserRouter>
			<UserProvider>
				<App />
			</UserProvider>
		</BrowserRouter>
	</React.StrictMode>
);
